const CLASS_NAME_TO_FUNCTION = {}

function beforeSaveReduxHookUtil (data) {
  const { className } = data
  const fn = CLASS_NAME_TO_FUNCTION[className]
  if (!fn) {
    return data
  }
  return fn(data)
}

export default beforeSaveReduxHookUtil
